export default "__VITE_ASSET__BUh_9bUU__"